import React from 'react'

import KinerjaHistoryApp from 'app/KinerjaPage/pages/Riwayat'
import KinerjaLayout from 'app/KinerjaPage/components/KinerjaLayout'
import { isToggleEnabled } from 'configs/toggle-feature'

export async function getServerSideProps() {
  const isKinerjaEnabled = await isToggleEnabled('kinerja-enabled')
  const isKinerjaKsEnabled = await isToggleEnabled('kinerja-ks-enabled')

  if (!isKinerjaEnabled) {
    return {
      redirect: {
        destination: '/404',
        permanent: false,
      },
    }
  }

  return { props: { isKinerjaKsEnabled } }
}

const KinerjaHistory = ({ isKinerjaKsEnabled }) => {
  return <KinerjaHistoryApp isKinerjaKsEnabled={isKinerjaKsEnabled} />
}

KinerjaHistory.Layout = KinerjaLayout

KinerjaHistory.layoutOpts = {
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
}

export default KinerjaHistory
